import { render, staticRenderFns } from "./caseBase.vue?vue&type=template&id=0b1c9401&scoped=true&"
import script from "./caseBase.vue?vue&type=script&lang=js&"
export * from "./caseBase.vue?vue&type=script&lang=js&"
import style0 from "./caseBase.vue?vue&type=style&index=0&id=0b1c9401&scoped=true&lang=less&"
import style1 from "./caseBase.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c9401",
  null
  
)

export default component.exports